import { CART_RECEIVE, CART_SHOW_INFO, CART_ADD_ERROR, CART_CLEAR_ERROR } from '../Actions/Cart.action';
import { error as errorReducer } from './Error.reducer';

export const cart = (state = { quantity: 0, orderTotal: 0, showInfo: false, errors: [] }, action) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
                errors: undefined
            };
        case CART_ADD_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case CART_CLEAR_ERROR:
            return {
                ...state,
                errors: undefined
            }
        default:
            return state;
    }
}